import { INDIVIDUAL_MAIL_THREAD_RECEIVERS_MAX_COUNT } from 'consts/mailThread/individualMailThreadReceiversMaxCount';

export const isGroupMailThreadVariant = (receiversCount: number) =>
    receiversCount > INDIVIDUAL_MAIL_THREAD_RECEIVERS_MAX_COUNT;
